import type { FunctionComponent } from 'react';
import { icons } from '../../../generic/Icon';
import SummaryActionOption from '../../generic/SummaryActionOption';
import SummaryStatPanel from '../../generic/SummaryStatPanel';
import { useCanDisplaySecurityOptions } from '../../generic/hooks';

type Props = {
  baseUrl: string;
  projectGroupId: number;
  selectedReleaseId: number;
  projectCount: number;
  dependencyCount: number;
  licenseCount: number;
  isReleaseSummaryStatusLoading: boolean;
};

export const ProjectGroupReleaseSummaryActionCards: FunctionComponent<Props> = ({
  baseUrl,
  projectGroupId,
  selectedReleaseId,
  projectCount,
  dependencyCount,
  licenseCount,
  isReleaseSummaryStatusLoading,
}) => {
  const isSecurityAndPDFReportsEnabled = useCanDisplaySecurityOptions();
  return (
    <>
      <SummaryStatPanel
        count={projectCount ?? '...'}
        label="Projects"
        icon={icons.folder}
        to={`${baseUrl}/projects`}
        isLoading={isReleaseSummaryStatusLoading}
      />
      <SummaryStatPanel
        count={dependencyCount ?? '...'}
        label="Dependencies"
        icon={icons.relationship}
        to={`${baseUrl}/browse/dependencies`}
        isLoading={isReleaseSummaryStatusLoading}
      />
      <SummaryStatPanel
        count={licenseCount ?? '...'}
        label="Licenses"
        icon={icons.edit}
        to={`${baseUrl}/browse/licenses`}
        isLoading={isReleaseSummaryStatusLoading}
      />
      <div className="card project_info__actions">
        <b className="inline-header">Actions</b>
        <ul className="nav nav-pills nav-stacked">
          <li>
            <SummaryActionOption
              action="Generate Compliance Report"
              icon={icons.addToProject}
              to={`${baseUrl}/reports/licensing`}
            />
          </li>
          {isSecurityAndPDFReportsEnabled && (
            <li>
              <SummaryActionOption
                action="Generate Vulnerability Report"
                icon={icons.addToProject}
                to={`${baseUrl}/reports/vulnerability`}
              />
            </li>
          )}
          <li>
            <SummaryActionOption
              action="Generate SBOM Report"
              icon={icons.addToProject}
              to={`${baseUrl}/reports/sbom`}
            />
          </li>
          <li>
            <SummaryActionOption
              action="Visit API Endpoint"
              icon={icons.api}
              to={`/api/project_group/${projectGroupId}/release/${selectedReleaseId}`}
              openInNewTab
            />
          </li>
        </ul>
      </div>
    </>
  );
};
